import Vue from 'vue'
import numeral from 'numeral'
import moment from 'moment'
import store from '../store'

Vue.filter('numFormat', function (num) {
  if (num === '-') { return '-' }
  if (num === '') { return '' }
  return numeral(num).format('0,0')
})
Vue.filter('cleanURL', function (url) {
  url = String(url)
  if (url.indexOf(' ') >= 0) {
    return url.substring(url.lastIndexOf(' ') + 1)
  } else {
    return url
  }
})
Vue.filter('dateOnlyFormat', function (date) {
  if (date) {
    return moment(String(date)).format(store.getters.getDateFormat)
  }
  return ''
})
Vue.filter('dateFormat', function (date) {
  if (date) {
    return moment(moment.utc(date)).local().format(store.getters.getDateFormat + ' ' + store.getters.getTimeFormat)
  }
  return ''
})
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})
Vue.filter('uppercase', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toUpperCase()
})
Vue.filter('humanize', function (value) {
  if (!value) return ''
  const words = value.split('_')
  return words.map((word) => {
    return word[0].toUpperCase() + word.substring(1)
  }).join(' ')
})
